import React from "react"
import CopyrightSection from "./CopyrightSection"
import SiteMapSection from "./SiteMapSection"

const Footer = ({footerMargin}) => {
	return (
		<React.Fragment>
			<div className={`w-full border border-t-[#B0B0B0] md:border-t-[#E7E7E7] ${footerMargin} px-4 pt-8 pb-32 md:pb-0`}>
				<SiteMapSection />
				<CopyrightSection />
			</div>
			<div className="text-center mt-1.5 pb-2 md:pb-0 px-4">
				<small className="copyright__content flex md:inline-flex flex-col md:flex-row items-center">
					<a href="https://www.withreach.com/terms-of-service" target="_blank">
						<img src="https://st.rch.io/logos/reach_r_black.png" className="h-5 m-2.5" />
					</a>
					All orders will be completed by our preferred international seller Reach US, CA, UK, EU, or AU.
				</small>
			</div>
		</React.Fragment>
	)
}

export default Footer